export default {
  survey: 'Survey',
  'survey.start': 'Complete survey',
  'survey.finish': 'Finish',

  'survey.notification.completed': 'Survey completed',

  'survey.facility-requested-survey':
    'Please answer a few questions before proceeding with the appointment booking.',
  'survey.error': 'An error occurred',
  'survey.error.description':
    'The selected form cannot be completed at this time. Please try again later.',

  'question.address.city': 'City',
  'question.address.house-number': 'House number',
  'question.address.zipcode': 'ZIP code',
  'question.address.street': 'Street',

  'question.email': 'Email',

  'question.document.upload.title': 'Upload file',

  'question.document.upload.download': 'Download',
  'question.document.upload.upload': 'Upload',

  'question.document.upload.description': 'Click here or drag file here',
  'question.document.upload.max-file-size': 'Maximum file size: 20MB',
  'question.document.upload.allowed-formats': 'Allowed file formats: PDF & DOCX',
  'question.document.upload.description.complete': 'File uploaded and confirmed',
  'question.document.upload.confirm-save':
    'Please check the uploaded document. It cannot be changed after confirmation.',
  'question.document.upload-success': 'File {fileName} uploaded successfully',
  'question.document.edit.upload': 'Upload document',
  'question.document.edit.save': 'Save changes',
  'question.document.download-document': 'Download file',
  'question.document.login-required': 'Login required',
  'question.document.login-required.description':
    'To continue processing the survey, the creation of a user account is necessary.',

  'question.document.max-file-size-exceeded':
    'File {fileName} is too large. Maximum file size: {maxFileSize} MB',
  'question.document.upload-error': 'Error uploading file {fileName}',
  'question.document.upload-error.virus-found':
      'This file could not be uploaded because it did not pass the security check.',
  'question.document.upload-error.file-too-large':
    'Upload failed: file is too large.',
  'question.document.file-deleted': 'File {fileName} has been deleted',

  'form.data-privacy-consent-missing.title': 'Privacy policy not yet accepted',
  'form.data-privacy-consent-missing.description':
    'To proceed with the appointment request, the {privacyLink} must be accepted.',
  'form.data-privacy-consent-missing.accept': 'Accept',

  'form.error': 'An error occurred',
};
